<template>
  <Head title="Check ETA by Pin Code" />
  <div class=" m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
    <div>
      <h1 class="mb-12 text-3xl font-bold">
        Check ETA by Pin code
      </h1>
    </div>
  </div>

  <div class=" m-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1">
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="checkEta">
        <div class="w-full p-5">
          <div class="w-full">
            <text-input v-model="form.pin_code" :error="form.errors.pin_code" class="pb-8 pr-6 w-full" label="Area PIN Code" />
            <loading-button :loading="form.processing" class="btn-indigo mb-5" type="submit">Check ETA</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div v-if="pinData" class=" m-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 mt-5">
    <div class="bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap -mb-4 -mr-3 p-4">
        <div class="pb-4 pr-3 w-full lg:w-1/4">Delivery ETA:  <div class="pt-4 font-bold text-lg">{{ pinData.surface_eta }} Days</div></div>
        <div class="pb-4 pr-3 w-full lg:w-1/4">State:  <div class="pt-4 font-bold text-lg">{{ pinData.state }}</div></div>
        <div class="pb-8 pr-3 w-full lg:w-1/4">City:  <div class="pt-4 font-bold text-lg">{{ pinData.city }}</div></div>
        <div class="pb-4 pr-3 w-full lg:w-1/4">Zone:  <div class="pt-4 font-bold text-lg">{{ pinData.zone }}</div></div>
      </div>
    </div>
  </div>

  <div v-if="invalidPin" class=" m-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 mt-5">
    <div class="bg-red-600 rounded-md shadow overflow-hidden p-5">
      <span class="pt-4 font-bold text-lg text-white">Pin code not found.</span>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    pinData: Object,
    pinCode: String,
    invalidPin: Boolean
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        pin_code: this.pinCode,
      }),
    }
  },
  methods: {
    checkEta () {
      if(this.form.pin_code.length !== 6) {
        window.alert('Please enter a valid pin code.');
        return;
      }

      this.$inertia.get('/tools/eta_checker?pin_code='+this.form.pin_code, {})
    },

  },
}
</script>
